import { Declaracion } from './../../../models/declaracion.model';
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

declare const swal: any;
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-declaracion",
    templateUrl: "./declaracion.component.html",
    styleUrls: ["./declaracion.component.css"],
    providers: [FormService]
})

export class DeclaracionComponent {
    typingTimeout: any;
    public rows = [];
    public actualRow;
    public declaracion: Declaracion;
    public form;
    public formulario;

    public form111 = false;
    public form112 = false;
    public form113 = false;
    public form114 = false;
    public form115 = false;

    public form131 = false;
    public form132 = false;
    public form133 = false;
    public form152 = false;
    public form154 = false;

    datatableMessages = {
        emptyMessage: 'No hay datos para mostrar',
        totalMessage: 'total',
        selectedMessage: 'seleccionado'
    };

    constructor(public _formService: FormService, private fb: FormBuilder, private cdr: ChangeDetectorRef) {

        this.formulario = localStorage.getItem("form")

        if (this.formulario == "1-1.1") {
            this.form111 = true;
        }
        if (this.formulario == "1-1.2") {
            this.form112 = true;
        }
        if (this.formulario == "1-1.3") {
            this.form113 = true;
        }
        if (this.formulario == "1-1.4") {
            this.form114 = true;
        }
        if (this.formulario == "1-1.5") {
            this.form115 = true;
        }

        if (this.formulario == "1-3.1") {
            this.form131 = true;
        }
        if (this.formulario == "1-3.2") {
            this.form132 = true;
        }
        if (this.formulario == "1-3.3") {
            this.form133 = true;
        }
        if (this.formulario == "1-5.2") {
            this.form152 = true;
        }
        if (this.formulario == "1-5.4") {
            this.form154 = true;
        }


        this.form = new FormGroup({
            plano: new FormControl(''),
            denominado: new FormControl(''),
            elaborado: new FormControl(''),
            profesion: new FormControl(''),
            forjas: new FormControl('', [Validators.pattern(/^\d+$/)]),
            numero: new FormControl('', [Validators.pattern(/^\d+$/)]),
            ano: new FormControl('', [Validators.pattern(/^\d+$/), Validators.maxLength(4)]),
            bienesRa: new FormControl(''),
            declaracionEstructura: new FormControl('')
        });

        if (!JSON.parse(localStorage.getItem("declaracion"))) {
            localStorage.setItem("declaracion", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("declaracion"));
            this.form.controls['plano'].setValue(this.rows[0] ? this.rows[0].plano : '');
            this.form.controls['denominado'].setValue(this.rows[0] ? this.rows[0].denominado : '');
            this.form.controls['elaborado'].setValue(this.rows[0] ? this.rows[0].elaborado : '');
            this.form.controls['profesion'].setValue(this.rows[0] ? this.rows[0].profesion : '')
            this.form.controls['forjas'].setValue(this.rows[0] ? this.rows[0].forjas : '');
            this.form.controls['numero'].setValue(this.rows[0] ? this.rows[0].numero : '');
            this.form.controls['ano'].setValue(this.rows[0] ? this.rows[0].ano : '');
            this.form.controls['bienesRa'].setValue(this.rows[0] ? this.rows[0].bienesRa : '')
            this.form.controls['declaracionEstructura'].setValue(this.rows[0] ? this.rows[0].declaracionEstructura : '')
        }
        this.declaracion = {
            plano: '',
            denominado: '',
            elaborado: '',
            profesion: '',
            forjas: '',
            numero: '',
            ano: '',
            bienesRa: '',
            declaracionEstructura: ''
        }
    }


    intervalId: any;

    ngOnInit() {
        // Cargar los datos iniciales
        this.loadFromLocalStorage();
    }

    ngOnDestroy(): void {
        // Limpia intervalo si lo estás usando
        clearInterval(this.intervalId);

        const valores = this.form.value;

        // Si hay una fila de datos en la tabla, úsala
        const filaTabla = this.rows[0] || {
            forjas: '',
            numero: '',
            ano: '',
            bienesRa: ''
        };

        const datosAGuardar = [{
            plano: valores.plano || '',
            denominado: valores.denominado || '',
            elaborado: valores.elaborado || '',
            profesion: valores.profesion || '',
            declaracionEstructura: valores.declaracionEstructura || '',
            forjas: filaTabla.forjas || '',
            numero: filaTabla.numero || '',
            ano: filaTabla.ano || '',
            bienesRa: filaTabla.bienesRa || ''
        }];

        localStorage.setItem('declaracion', JSON.stringify(datosAGuardar));
    }

    loadFromLocalStorage() {
        const storedData = JSON.parse(localStorage.getItem('declaracion'));
        if (storedData && storedData.length > 0) {
            this.rows = storedData;
            this.cdr.detectChanges();
            this.form.controls["plano"].setValue(this.rows[0] ? this.rows[0].plano : "");
            this.form.controls["denominado"].setValue(this.rows[0] ? this.rows[0].denominado : "");
            this.form.controls["elaborado"].setValue(this.rows[0] ? this.rows[0].elaborado : "");
            this.form.controls["profesion"].setValue(this.rows[0] ? this.rows[0].profesion : "");
            this.form.controls["declaracionEstructura"].setValue(this.rows[0] ? this.rows[0].declaracionEstructura : "");
        }
    }

    preventInvalidKeys(event: KeyboardEvent): void {
        const invalidChars = ['e', 'E', '+', '-', ',', '.'];
        if (invalidChars.includes(event.key)) {
            event.preventDefault();
        }
    }

    add_declaracion() {
        const valores = this.form.value;
        const declaracionRaw = localStorage.getItem("declaracion");
        this.rows = declaracionRaw ? JSON.parse(declaracionRaw) : [];

        const camposRequeridos = ['forjas', 'numero', 'ano', 'bienesRa'];

        const todosTienenDatos = camposRequeridos.every(campo =>
            valores[campo] !== null &&
            valores[campo] !== undefined &&
            valores[campo].toString().trim() !== ''
        );

        // Validaciones adicionales
        const esNumerico = (val: any) =>
            val !== null && val !== undefined && /^\d+$/.test(val.toString());
        const errores: string[] = [];

        if (!esNumerico(valores.forjas)) {
            errores.push('El campo "Inscrito a fojas" debe ser numérico.');
        }

        if (!esNumerico(valores.numero)) {
            errores.push('El campo "Número" debe ser numérico.');
        }

        if (!esNumerico(valores.ano)) {
            errores.push('El campo "Año" debe ser numérico.');
        } else if (valores.ano.toString().length > 4) {
            errores.push('El campo "Año" no debe tener más de 4 dígitos.');
        }

        if (errores.length > 0) {
            swal({
                icon: 'error',
                title: 'Error de validación',
                text: errores.join('\n'),
                buttons: {
                    confirm: {
                        text: 'Aceptar',
                        value: true,
                        visible: true
                    }
                }
            });
            return;
        }

        if (this.rows[0] && this.rows[0].forjas === "") {
            Object.assign(this.rows[0], {
                forjas: valores.forjas,
                numero: valores.numero,
                ano: valores.ano,
                bienesRa: valores.bienesRa,
            });
        } else if (todosTienenDatos) {
            this.rows.push({
                plano: valores.plano,
                denominado: valores.denominado,
                elaborado: valores.elaborado,
                profesion: valores.profesion,
                forjas: valores.forjas,
                numero: valores.numero,
                ano: valores.ano,
                bienesRa: valores.bienesRa,
                declaracionEstructura: valores.declaracionEstructura,
            });

            this.form.patchValue({
                numero: '',
                forjas: '',
                ano: '',
                bienesRa: '',
            });
        } else {
            swal({
                icon: 'error',
                title: 'Faltan campos obligatorios',
                text: 'Por favor, revisar la sección de declaración jurada, por posibles datos requeridos.',
                buttons: {
                    confirm: {
                        text: 'Aceptar',
                        value: true,
                        visible: true
                    }
                }
            });
        }

        localStorage.setItem("declaracion", JSON.stringify(this.rows));
    }

    addPlano(): void {
        var declaracionRaw = localStorage.getItem("declaracion");
        var rows = declaracionRaw ? JSON.parse(declaracionRaw) : [];

        var nuevoValor = this.form.get('plano') ? this.form.get('plano').value : '';

        if (rows.length > 0 && rows[0]) {
            rows[0].plano = nuevoValor;
        } else {
            rows = [{
                plano: nuevoValor,
                denominado: '',
                elaborado: '',
                profesion: '',
                declaracionEstructura: '',
                forjas: '',
                numero: '',
                ano: '',
                bienesRa: ''
            }];
        }

        localStorage.setItem("declaracion", JSON.stringify(rows));
    }

    deleteFojasRow(row) {
        const index = this.rows.findIndex(data => data.plano === row.plano);
        if (index !== -1) {
            this.rows.splice(index, 1);
            localStorage.setItem("declaracion", JSON.stringify(this.rows));
        }
    }
}